import './ratings-compliances.scss'

import { Card, Skeleton, Statistic, Table, Typography } from 'antd'
import React from 'react'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetchDetailByDomain } from '../../../../api'
import { emptyCharacter } from '../../../../components/EmptyChar'
import { renderPrincipal } from '../../../../components/tables/table-column-renderers'
import { IsCompliant, renderIsCompliant } from '../IsCompliant'
import { RatingsCompliancesProps } from './models'
import { buildShortAndLongCompliancesColumns } from './ratings-compliances-table-columns'

export const RatingsCompliances = ({ tenant }) => {
  const { data: ratingsCompliances } = useSWR<RatingsCompliancesProps>(
    tenant ? ['/compliances/ratings', tenant] : null,
    fetchDetailByDomain,
  )

  if (!ratingsCompliances) {
    return <Skeleton />
  }

  return (
    <Column className="ratings">
      <Card>
        <Row justifyContentSpaceBetween>
          <Statistic title="Trades Count" value={ratingsCompliances.tradesCount} />
          <Statistic title="Amount Invested ($)" value={renderPrincipal(ratingsCompliances.amountInvested)} />
          <Statistic title="Is Compliant" valueRender={() => renderIsCompliant(ratingsCompliances.isCompliant)} />
          <Statistic
            title="Long Term Compliant Only"
            valueRender={() => renderIsCompliant(ratingsCompliances.longTermComplianceOnly)}
          />
          <Statistic title="Capital Basis" value={ratingsCompliances?.capitalBasis || emptyCharacter} />
        </Row>
      </Card>
      <RatingTable {...ratingsCompliances.long} title="Long Rating Compliances" />
      {ratingsCompliances.short ? (
        <RatingTable {...ratingsCompliances.short} title="Short Rating Compliances" />
      ) : (
        <Card title="Short Rating Compliances">
          <Typography>There is no Short Rating Compliances once the tenant is Long Term Compliance Only</Typography>
        </Card>
      )}
    </Column>
  )
}

const RatingTable = ({ title, isCompliant, investmentSharePct, tradesCount, amountInvested, ratings }) => (
  <Card title={title} className="rating-compliances" loading={!ratings}>
    <Row justifyContentSpaceBetween>
      <Column>
        <dt>Trades Count</dt>
        <dd>{tradesCount}</dd>
      </Column>
      <Column>
        <dt>Amount Invested ($)</dt>
        <dd>{renderPrincipal(amountInvested)}</dd>
      </Column>
      <Column>
        <dt>Is Compliant</dt>
        <dd>
          <IsCompliant isCompliant={isCompliant} />
        </dd>
      </Column>
      <Column>
        <dt>Investment Share Percentage (%)</dt>
        <dd>{investmentSharePct}</dd>
      </Column>
    </Row>

    <Table
      dataSource={ratings || []}
      loading={!ratings}
      columns={buildShortAndLongCompliancesColumns}
      pagination={false}
      rowKey="rating"
      size="small"
    />
  </Card>
)
